export const INVALID_PHONE = 'INVALID_PHONE';
export const MISSING_PHONE = 'MISSING_PHONE';
export const MISSING_ADDRESS_FIRSTNAME = 'MISSING_ADDRESS_FIRSTNAME';
export const INVALID_ADDRESS_FIRSTNAME = 'INVALID_ADDRESS_FIRSTNAME';
export const MISSING_ADDRESS_LASTNAME = 'MISSING_ADDRESS_LASTNAME';
export const INVALID_ADDRESS_LASTNAME = 'INVALID_ADDRESS_LASTNAME';
export const MISSING_CARD_NUMBER = 'MISSING_CARD_NUMBER';
export const UNSUPPORTED_CREDIT_BRAND = 'UNSUPPORTED_CREDIT_BRAND';
export const MISSING_CARD_TYPE = 'MISSING_CARD_TYPE';
export const INVALID_CARD_NUMBER = 'INVALID_CARD_NUMBER';
export const INVALID_DEBIT_DISABLED_FOR_CREDIT = 'INVALID_DEBIT_DISABLED_FOR_CREDIT';
export const INVALID_CARD_TYPE = 'INVALID_CARD_TYPE';
export const MISSING_POSTAL_CODE = 'MISSING_POSTAL_CODE';
export const INVALID_POSTAL_CODE = 'INVALID_POSTAL_CODE';
export const MISSING_ADDRESS_LINE1 = 'MISSING_ADDRESS_LINE1';
export const INVALID_ADDRESS_LINE1 = 'INVALID_ADDRESS_LINE1';
export const MISSING_CITY = 'MISSING_CITY';
export const INVALID_CITY = 'INVALID_CITY';
export const MISSING_COUNTRY_ABBREVIATION = 'MISSING_COUNTRY_ABBREVIATION';
export const INVALID_COUNTRY_CODE = 'INVALID_COUNTRY_CODE';
export const INVALID_COUNTRY_ABBREVIATION = 'INVALID_COUNTRY_ABBREVIATION';
export const MISSING_STATE_ABBREVIATION = 'MISSING_STATE_ABBREVIATION';
export const INVALID_STATE_ABBREVIATION = 'INVALID_STATE_ABBREVIATION';
export const MISSING_CARD_EXPIRY_DETAILS = 'MISSING_CARD_EXPIRY_DETAILS';
export const INVALID_CARD_EXPIRATION_YEAR = 'INVALID_CARD_EXPIRATION_YEAR';
export const INVALID_CARD_EXPIRATION_IN_PAST = 'INVALID_CARD_EXPIRATION_IN_PAST';
export const INVALID_CARD_EXPIRATION_MONTH = 'INVALID_CARD_EXPIRATION_MONTH';
export const INVALID_UNIT = 'INVALID_UNIT';
export const INVALID_ACCOUNT_TYPE = 'INVALID_ACCOUNT_TYPE';
export const INVALID_ACCOUNT_ROUTING_NUMBER = 'INVALID_ACCOUNT_ROUTING_NUMBER';
export const INVALID_FINANCIAL_INSTITUTION_NUMBER = 'INVALID_FINANCIAL_INSTITUTION_NUMBER';
export const INVALID_BRANCH_NUMBER = 'INVALID_BRANCH_NUMBER';
export const INVALID_CANADA_EFT_LAST_FOUR = 'INVALID_CANADA_EFT_LAST_FOUR';
export const INVALID_ACCOUNT_FIRSTNAME = 'INVALID_ACCOUNT_FIRSTNAME';
export const INVALID_ACCOUNT_LASTNAME = 'INVALID_ACCOUNT_LASTNAME';
export const INVALID_ACCOUNT_NUMBER = 'INVALID_ACCOUNT_NUMBER';
export const MISSING_ACCOUNT_TYPE = 'MISSING_ACCOUNT_TYPE';
export const MISSING_ACCOUNT_FIRSTNAME = 'MISSING_ACCOUNT_FIRSTNAME';
export const MISSING_ACCOUNT_LASTNAME = 'MISSING_ACCOUNT_LASTNAME';
export const MISSING_ACCOUNT_NUMBER = 'MISSING_ACCOUNT_NUMBER';
export const MISSING_ACCOUNT_ROUTING_NUMBER = 'MISSING_ACCOUNT_ROUTING_NUMBER';
export const MISSING_FINANCIAL_INSTITUTION_NUMBER = 'MISSING_FINANCIAL_INSTITUTION_NUMBER';
export const MISSING_BRANCH_NUMBER = 'MISSING_BRANCH_NUMBER';
export const MISSING_CANADA_EFT_LAST_FOUR = 'MISSING_CANADA_EFT_LAST_FOUR';
export const FAILURE_DEBIT_AUTHORIZATION = 'FAILURE_DEBIT_AUTHORIZATION';
export const FAILURE_DEBIT_AVS_CHECK = 'FAILURE_DEBIT_AVS_CHECK';
export const CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT = 'CLAWBACK_OPTION_EXPIRES_BEFORE_EVENT';
export const DATE_TBA_ERROR = 'DATE_TBA_ERROR';
